var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinLitecoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.766,
    y: 0.416,
    width: 51.056,
    height: 51.056,
    rx: 25.528,
    fill: "#C8C8C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.454 32.689l1.593-5.997 3.77-1.378.938-3.524-.032-.087-3.711 1.356 2.674-10.07h-7.584L19.605 26.13l-2.92 1.067-.965 3.633 2.918-1.066-2.061 7.744H36.76l1.294-4.82h-12.6z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinLitecoin);
export default __webpack_public_path__ + "static/media/coin-litecoin.4fdc3b056ed36901e2921d6b7131d499.svg";
export { ForwardRef as ReactComponent };